import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import Image, { FluidObject } from "gatsby-image"

import { getDiscountedPrice, IPrice, forDisplay } from "../helpers"

interface Props {
  fluid: FluidObject
  title: string
  price?: IPrice
  withTitle?: boolean
  suffix?: string
}

export const Product: React.FC<Props> = ({
  fluid,
  title,
  price,
  suffix = "lb",
  withTitle = false,
}) => (
  <StyledProduct.Wrapper>
    <StyledProduct.Image
      fluid={fluid}
      alt={`${title}`}
      imgStyle={{
        objectFit: "contain",
      }}
    />
    {withTitle && <StyledProduct.Title>{title}</StyledProduct.Title>}
    {price && (
      <StyledProduct.Price>
        {forDisplay.discountedPrice(price.original, price.discount, suffix)}
        {!!price.discount && (
          <StyledProduct.DiscountedPrice>
            <StyledProduct.OldPrice>
              {forDisplay.price(price.original, suffix)}
            </StyledProduct.OldPrice>
            <span>·</span>
            <span>{forDisplay.discount(price.discount)}</span>
          </StyledProduct.DiscountedPrice>
        )}
      </StyledProduct.Price>
    )}
  </StyledProduct.Wrapper>
)

const StyledProduct = {
  Wrapper: tw.div`cursor-pointer h-full flex flex-col justify-around`,
  Image: tw(Image)`w-48 h-40`,
  Title: tw.h1`text-lg font-semibold mt-4`,
  Price: tw.h3`flex flex-col text-base font-semibold`,
  DiscountedPrice: styled.span`
    ${tw`flex items-center text-sm text-gray-500 font-semibold`}

    & > *:not(:last-child) {
      ${tw`mr-2`}
    }
  `,
  OldPrice: tw.span`line-through`,
}
